<template>
  <div class="SerialUnassigned">
    <ATable
      ref="table"
      v-loading="loading"
      min-height="200px"
      max-height="758px"
      :data="items"
      :placeholder="placeholder"
      :search_field="search_field"
      hide-button-insert
      hide-pagination
      border
      @selection-change="handleSelectionChange"
    >
      <div slot="search">
        <div class="inline">입고일</div>
        <div class="inline ml-default">
          <APeriodSelector 
            ref="period" 
            @change="handleChangePeriod" 
          />
        </div>
        <div class="inline">
          <el-button
            type="primary"
            size="mini"
            round
            v-shortkey="['f5']"
            @shortkey.native="handleClickSearch"
            @click="handleClickSearch"
          >검색(F5)</el-button>
        </div>
      </div>
      <el-table-column 
        type="selection" 
        align="center"
        :width="$width.selection"
      />
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"            
        :width="$width.indexw"
      />
      <el-table-column
        prop="code"
        label="관리품번"
      />
      <el-table-column
        prop="product_name"
        label="관리품명"
      />
      <el-table-column
        prop="inbound_date"        
        label="입고일"
        :width="$width.date"
      />
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <div slot="buttons">
        <el-button
          :disabled="selection.length < 1"
          @click="handleClickPrint"
        >{{$t('title.serial_print')}}</el-button>
      </div>
    </ATable>
    <el-dialog      
      custom-class="form-dialog"
      top="0"
      width="450px"
      destroyOnClose
      :title="$t('title.serial_print')"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
    >
      <SerialSelectPrint
        v-if="dialog_visible"
        :items="selection"
        @completed="handleCompletedPrint"
      />
    </el-dialog>
  </div>
</template>
<script>
import SerialSelectPrint from "./SerialSelectPrint";

export default {
  name: "SerialUnassigned",
  components: {SerialSelectPrint},
  data() {
    return {
      title: this.$t("title.serial"),
      loading: false,
      items: [],
      placeholder: '관리코드, 관리품명',
      search_field: ["code", "product_name"],
      period: {},
      selection: [],
      dialog_visible: false,
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api.listSerial(this.period).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },
    handleChangePeriod(value) {
      this.period = value;
      this.handleClickSearch();
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleClickPrint() {
      this.dialog_visible = true;
    },
    handleCompletedPrint() {
      this.dialog_visible = false;
    },
  },
}
</script>